// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"84554ef2","826":"86370c5a","997":"90f11639"}[chunkId] + ".chunk.css";
};